import { Button } from "rizzui";
import { PiXBold } from "react-icons/pi";

export default function ImageViewer({ path, onClose }: { path: string; onClose: any }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-full max-w-4xl p-4 bg-white rounded-lg shadow-lg">
        <Button
          rounded="pill"
          className="absolute top-4 right-4 z-10 h-[30px] w-[30px] p-1"
          onClick={onClose}
        >
          <PiXBold className="w-5 h-5 text-gray-100" />
        </Button>
        <div className="aspect-w-16 aspect-h-9">
          <img
            src={path}
            alt="Product"
            className="object-cover w-full h-full rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}
